import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-sm shadow-sm" data-id="element-231">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between" data-id="element-232">
        <div className="flex items-center" data-id="element-233">
          <Link to="/" data-id="element-234">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/orQ3K3RDiw2VErqgKJWrFu/LIFE_FORTE_SOLUTIONS_3.png" alt="Life Fort Solutions Logo" className="h-12 mr-2" data-id="element-235" />
          </Link>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-236">
          <Link to="/" className="text-gray-700 hover:text-blue-800 font-medium transition" data-id="element-237">
            Home
          </Link>
          <a href="/#about" className="text-gray-700 hover:text-blue-800 font-medium transition" data-id="element-238">
            About
          </a>
          <a href="/#services" className="text-gray-700 hover:text-blue-800 font-medium transition" data-id="element-239">
            Services
          </a>
          <a href="/#approach" className="text-gray-700 hover:text-blue-800 font-medium transition" data-id="element-240">
            Our Approach
          </a>
          <Link to="/insights" className="text-gray-700 hover:text-blue-800 font-medium transition" data-id="element-241">
            Insights
          </Link>
          <a href="/#contact" className="bg-blue-800 text-white px-5 py-2 rounded-md hover:bg-blue-700 transition" data-id="element-242">
            Contact Us
          </a>
        </nav>
        {/* Mobile menu button */}
        <button className="md:hidden text-gray-700" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-243">
          {isMenuOpen ? <XIcon size={24} data-id="element-244" /> : <MenuIcon size={24} data-id="element-245" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white border-t" data-id="element-246">
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-4" data-id="element-247">
            <Link to="/" className="text-gray-700 hover:text-blue-800 font-medium transition py-2" onClick={() => setIsMenuOpen(false)} data-id="element-248">
              Home
            </Link>
            <a href="/#about" className="text-gray-700 hover:text-blue-800 font-medium transition py-2" onClick={() => setIsMenuOpen(false)} data-id="element-249">
              About
            </a>
            <a href="/#services" className="text-gray-700 hover:text-blue-800 font-medium transition py-2" onClick={() => setIsMenuOpen(false)} data-id="element-250">
              Services
            </a>
            <a href="/#approach" className="text-gray-700 hover:text-blue-800 font-medium transition py-2" onClick={() => setIsMenuOpen(false)} data-id="element-251">
              Our Approach
            </a>
            <Link to="/insights" className="text-gray-700 hover:text-blue-800 font-medium transition py-2" onClick={() => setIsMenuOpen(false)} data-id="element-252">
              Insights
            </Link>
            <a href="/#contact" className="bg-blue-800 text-white px-5 py-2 rounded-md hover:bg-blue-700 transition text-center" onClick={() => setIsMenuOpen(false)} data-id="element-253">
              Contact Us
            </a>
          </div>
        </div>}
    </header>;
};